import React from "react";
import { useHistory } from "react-router-dom";

import { useBrowserPageTitle } from "../../../components/BrowserPageTitle/BrowserPageTitle";
import { PayrollRunDetailsContractor } from "../../PayrollRuns/components/PayrollRunDetailsContractor";
import {
  PATH_PAYABLES,
  routeHelpersPayablesPayrollRun,
  routeHelpersPayablesTab
} from "../paths";

/**
 * One contractor payroll run, opened from the Payables "Payroll Runs" tab.
 *
 * The screen keeps the retired v1 layout; this wrapper supplies the Payables
 * breadcrumbs and the base path the payable detail sidebar mounts under (which
 * keeps a payable opening in place, over the run, exactly as the v1 screen did).
 */
export const RoutePayablesPayrollRun: React.FC = () => {
  useBrowserPageTitle("Payroll Run");

  const history = useHistory();
  const goToPayablesTab = routeHelpersPayablesTab.useGoTo();
  const {
    params: { payrollRunId }
  } = routeHelpersPayablesPayrollRun.useData();

  return (
    <PayrollRunDetailsContractor
      breadcrumbs={[
        { label: "Payables", onClick: () => history.push(PATH_PAYABLES) },
        {
          label: "Payroll runs",
          onClick: () => goToPayablesTab({ tab: "payroll-runs" })
        }
      ]}
      payablesDetailsBasePath={
        routeHelpersPayablesPayrollRun.createLocationObject({ payrollRunId })
          .pathname
      }
      payrollRunId={payrollRunId}
    />
  );
};
